const getExtension = (rootState, slug) =>
  rootState.ws.extensions.find((extension) => extension.slug === slug);

export default getExtension;
